import { TextField } from "@mui/material";

import Grid from "@mui/material/Grid";
import React from "react";
import _ from "lodash";
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  paper: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  dropdowns: {
    marginTop: "16px"
  }
}));

export default function Form({
  entry = null,
  errors = [],
  setEntry,
  loading,
  onSetDirty = null,
}) {
  const classes = useStyles();

  const onInputChange = (event, property) => {
    setEntry({ ...entry, [property]: event.target.value });
    if (onSetDirty !== null) onSetDirty(true);
  };

  return entry === null ? null : (
    <React.Fragment>
      <Grid container className={classes.paper} spacing={2}>
        <Grid item sm={6}>
          <TextField
            margin="normal"
            fullWidth
            error={_.isArray(errors.Name)}
            helperText={
              _.isArray(errors.Name) && errors.Name.join()
            }
            disabled={loading}
            label="Name"
            value={entry.name}
            required={true}
            onChange={(event) => onInputChange(event, "name")}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
